export interface Tenant {
  id: string;
  name: string;
}

export interface Config {
  api_base_url: string;
  tenant_login_url: string;
  tenant_refresh_url: string;
  identity_server_url: string;
  password_reset_base_url?: string;
  tenant: string;
  posthog_host: string;
  posthog_key: string;
  posthog_debug: boolean;
  posthog_disabled: boolean;
  environment: string; // e.g., "humana-production", "production"
  support_url?: string;
  isInternalInstance?: boolean; // true only for admin-benefits.thehelperbees.com
  available_tenants?: Tenant[];
  // Keycloak SSO configuration
  keycloak_url?: string;
  keycloak_realm?: string;
  keycloak_client_id?: string;
  keycloak_idp_domain_map?: string; // e.g., "humana.com:humana-okta,thehelperbees.com:thb-internal"
  enabled_features?: string[];
  // homeAlign / Consumer Portal URL for the FlexCard redirect gate.
  // Production convention: https://<tenant>.myhomealign.com.
  // Staging convention:    https://<tenant>.myhaapp.com.
  // Set explicitly per env so the dialog doesn't ship a staging CM to the
  // production portal (or vice versa). When unset, the dialog falls back to
  // the production convention.
  ha_portal_url?: string;
  // Sanity (CMS) configuration — per-tenant; absent = feature disabled
  sanity_project_id?: string;
  sanity_dataset?: string;
  sanity_api_version?: string;
  sanity_use_cdn?: boolean;
  sanity_token?: string;
  sanity_client_names?: string[]; // parsed from CSV in window.ENV.sanity_client_names
}

declare global {
  interface Window {
    ENV: Omit<Config, "sanity_client_names"> & { sanity_client_names?: string };
  }
}

const parseClientNames = (raw: string | undefined): string[] => {
  if (!raw) return [];
  return raw
    .split(",")
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
};

export const Config: Config = {
  ...window.ENV,
  sanity_client_names: parseClientNames(window.ENV.sanity_client_names),
};

export const getEnvironmentType = (): string => {
  if (Config.environment?.includes("production")) return "production";
  if (Config.environment?.includes("staging")) return "staging";
  if (Config.environment?.includes("development")) return "development";
  return Config.environment || "development";
};
